module.exports = __webpack_public_path__ + "img/Frame 935one.4b1e1270.svg";